import { UsersSortByParam } from "@bvhi/backend-api";
import { GridSortItem } from "@bvhi/ui-base";
import { useCallback } from "react";

export interface SortConfig {
  backendString: string;
  dataGridSortModel: GridSortItem;
}

const config: SortConfig[] = [
  {
    backendString: UsersSortByParam.EMAIL_ASC,
    dataGridSortModel: {
      field: "email",
      sort: "asc",
    },
  },
  {
    backendString: UsersSortByParam.EMAIL_DESC,
    dataGridSortModel: {
      field: "email",
      sort: "desc",
    },
  },
  {
    backendString: UsersSortByParam.FIRST_NAME_ASC,
    dataGridSortModel: {
      field: "firstName",
      sort: "asc",
    },
  },
  {
    backendString: UsersSortByParam.FIRST_NAME_DESC,
    dataGridSortModel: {
      field: "firstName",
      sort: "desc",
    },
  },
  {
    backendString: UsersSortByParam.LAST_NAME_ASC,
    dataGridSortModel: {
      field: "lastName",
      sort: "asc",
    },
  },
  {
    backendString: UsersSortByParam.LAST_NAME_DESC,
    dataGridSortModel: {
      field: "lastName",
      sort: "desc",
    },
  },
  {
    backendString: UsersSortByParam.UPDATED_AT_ASC,
    dataGridSortModel: {
      field: "updatedAt",
      sort: "asc",
    },
  },
  {
    backendString: UsersSortByParam.UPDATED_AT_DESC,
    dataGridSortModel: {
      field: "updatedAt",
      sort: "desc",
    },
  },
];

export const useUsersSortParams = () => {
  const isFieldSortable = useCallback((fieldName: string): boolean => {
    const configItem = config.find((item) => item.dataGridSortModel.field === fieldName);
    if (configItem) return true;
    return false;
  }, []);

  const getSortModelForBackendString = useCallback((backendString: string): GridSortItem => {
    const item = config.find((item) => item.backendString === backendString);
    return item?.dataGridSortModel ?? config[0].dataGridSortModel;
  }, []);

  const getSortConfig = useCallback((sortModel?: GridSortItem) => {
    if (!sortModel) return config[0];
    const item = config.find((item) => item.dataGridSortModel.field === sortModel.field && item.dataGridSortModel.sort === sortModel.sort);
    return item ?? config[0];
  }, []);

  return { isFieldSortable, getSortConfig, getSortModelForBackendString };
};
